export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '80'},
    {prop: 'remark', label: '备注', minWidth: '80'},
    {prop: 'unionId', label: 'UnionID', minWidth: '80'},
    {prop: 'corpName', label: '主体名称', minWidth: '80'},
    {prop: 'sid', label: '账号ID', minWidth: '80'},
    {prop: 'usedBy', label: '使用人', minWidth: '60'},
    {prop: 'deptName', label: '所属岗位', minWidth: '60'},
    {prop: 'groupName', label: '所属组', minWidth: '80'},
    {prop: 'createdAt', label: '添加时间', minWidth: '80', sortable: 'custom'},
    {prop: 'deletedAt', label: '删除时间', minWidth: '80'},
    {prop: 'deleted', label: '是否已删除', minWidth: '60'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
